function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "path-1",
  cx: 18,
  cy: 18,
  r: 18
}), /*#__PURE__*/React.createElement("filter", {
  x: "-18.1%",
  y: "-15.3%",
  width: "136.1%",
  height: "136.1%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.294117647   0 0 0 0 0.250980392   0 0 0 0 0.22745098  0 0 0 0.3 0",
  type: "matrix",
  in: "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0 0.169425 17.508375 0.169425 17.508375 22.49955 0 22.49955"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "menu/icon-Onboarding-Survey",
  transform: "translate(4.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "survey-orange"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Oval"
}, /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FF7412",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
})))), /*#__PURE__*/React.createElement("g", {
  id: "Onboarding-Survey-white",
  transform: "translate(9.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(0.000000, 0.955800)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.6057875,20.5488 C16.6057875,21.2058 15.9645375,21.598425 15.3435375,21.598425 L2.1652875,21.598425 C1.5442875,21.598425 0.9019125,21.2058 0.9019125,20.5488 L0.9019125,5.20155 C0.9615375,4.536675 1.5037875,4.03155 2.1641625,4.0203 L4.2859125,4.0203 L4.2859125,5.470425 C4.3084125,5.71005 4.5154125,5.895675 4.7606625,5.895675 C4.7696625,5.895675 4.7764125,5.895675 4.7854125,5.89455 L12.6919125,5.89455 C12.7009125,5.895675 12.7110375,5.895675 12.7200375,5.895675 C12.9765375,5.895675 13.1891625,5.7123 13.2240375,5.459175 L13.2229125,4.0203 L15.3435375,4.0203 C16.0061625,4.03155 16.5472875,4.5378 16.6057875,5.1948 L16.6057875,20.5488 Z M5.1881625,2.680425 L6.7451625,2.680425 C6.9577875,2.65455 7.1321625,2.48805 7.1704125,2.268675 C7.3402875,1.5363 7.9781625,1.013175 8.7251625,0.992925 C9.4721625,1.015425 10.0999125,1.53855 10.2562875,2.2653 C10.2979125,2.49255 10.4869125,2.66355 10.7164125,2.680425 L12.3206625,2.680425 L12.3206625,4.9923 L5.1881625,4.9923 L5.1881625,2.680425 Z M15.3435375,3.116925 L13.2229125,3.116925 L13.2229125,2.122425 C13.2229125,1.88505 12.9472875,1.77705 12.6919125,1.77705 L11.0516625,1.77705 L11.0325375,1.7208 C10.6927875,0.749925 9.8310375,0.171675 8.7274125,0.171675 C8.6970375,0.17055 8.6655375,0.169425 8.6351625,0.169425 C7.6417875,0.169425 6.7620375,0.783675 6.4222875,1.721925 L6.4031625,1.77705 L4.7899125,1.77705 C4.6020375,1.77705 4.2859125,1.850175 4.2859125,2.122425 L4.2859125,3.116925 L2.1652875,3.116925 C1.0065375,3.1293 0.0547875,4.0473 -0.0003375,5.20605 L-0.0003375,20.5488 C-0.0003375,21.6243 0.9716625,22.49955 2.1652875,22.49955 L15.3435375,22.49955 C16.5371625,22.49955 17.5091625,21.6243 17.5091625,20.5488 L17.5091625,5.20155 C17.4540375,4.0473 16.5034125,3.130425 15.3435375,3.116925 L15.3435375,3.116925 Z",
  id: "Fill-1",
  fill: "#61B3CD",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M2.8157625,14.5634625 L3.9137625,15.6873375 C3.9913875,15.7750875 4.0993875,15.8223375 4.2118875,15.8223375 L4.2253875,15.8223375 C4.3468875,15.8212125 4.4593875,15.7728375 4.5426375,15.6873375 L6.6340125,13.7028375 C6.8072625,13.5453375 6.8196375,13.2742125 6.6598875,13.1020875 L6.6306375,13.0728375 C6.4618875,12.8962125 6.1783875,12.8860875 5.9995125,13.0503375 L4.2253875,14.7400875 L3.4446375,13.9300875 C3.3546375,13.8367125 3.2353875,13.7883375 3.1161375,13.7883375 C3.0081375,13.7883375 2.8978875,13.8277125 2.8112625,13.9075875 C2.6402625,14.0875875 2.6402625,14.3789625 2.8157625,14.5634625",
  id: "Fill-4",
  fill: "#61B3CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.830425,14.70195 C14.830425,14.453325 14.627925,14.25195 14.3793,14.25195 L8.2188,14.25195 C7.96905,14.25195 7.767675,14.453325 7.767675,14.70195 C7.767675,14.9517 7.96905,15.153075 8.2188,15.153075 L14.3793,15.153075 C14.627925,15.153075 14.830425,14.9517 14.830425,14.70195",
  id: "Fill-6",
  fill: "#61B3CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.6335625,9.4174875 C6.7179375,9.3409875 6.7674375,9.2363625 6.7719375,9.1227375 C6.7764375,9.0102375 6.7370625,8.9011125 6.6594375,8.8178625 C6.6526875,8.8077375 6.6448125,8.7998625 6.6358125,8.7919875 L6.6301875,8.7874875 C6.4636875,8.6097375 6.1813125,8.6018625 6.0001875,8.7649875 L4.2249375,10.4547375 L3.4441875,9.6447375 C3.3541875,9.5502375 3.2349375,9.5029875 3.1156875,9.5029875 C3.0065625,9.5029875 2.8985625,9.5412375 2.8119375,9.6222375 C2.6398125,9.8022375 2.6398125,10.0936125 2.8153125,10.2781125 L3.9133125,11.4019875 C3.9920625,11.4897375 4.1000625,11.5381125 4.2136875,11.5381125 L4.2249375,11.5381125 C4.3453125,11.5369875 4.4600625,11.4863625 4.5433125,11.4019875 L6.6335625,9.4174875 Z",
  id: "Fill-8",
  fill: "#61B3CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.830425,10.41615 C14.830425,10.167525 14.627925,9.96615 14.3793,9.96615 L8.2188,9.96615 C7.96905,9.96615 7.767675,10.167525 7.767675,10.41615 C7.767675,10.6659 7.96905,10.867275 8.2188,10.867275 L14.3793,10.867275 C14.627925,10.867275 14.830425,10.6659 14.830425,10.41615",
  id: "Fill-10",
  fill: "#61B3CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.6335625,17.988975 C6.8068125,17.83035 6.8191875,17.56035 6.6594375,17.388225 C6.6526875,17.3781 6.6448125,17.370225 6.6358125,17.36235 L6.6301875,17.35785 C6.4636875,17.1801 6.1813125,17.1711 6.0001875,17.336475 L4.2249375,19.026225 L3.4441875,18.2151 C3.3541875,18.1206 3.2349375,18.07335 3.1168125,18.07335 C3.0076875,18.07335 2.8996875,18.112725 2.8119375,18.193725 C2.6386875,18.373725 2.6386875,18.663975 2.8153125,18.8496 L3.9133125,19.973475 C3.9920625,20.061225 4.1000625,20.108475 4.2136875,20.108475 L4.2249375,20.108475 C4.3441875,20.10735 4.4600625,20.05785 4.5433125,19.973475 L6.6335625,17.988975 Z",
  id: "Fill-12",
  fill: "#61B3CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.830425,18.9876375 C14.830425,18.7378875 14.627925,18.5365125 14.3793,18.5365125 L8.2188,18.5365125 C7.96905,18.5365125 7.767675,18.7378875 7.767675,18.9876375 C7.767675,19.2362625 7.96905,19.4376375 8.2188,19.4376375 L14.3793,19.4376375 C14.627925,19.4376375 14.830425,19.2362625 14.830425,18.9876375",
  id: "Fill-14",
  fill: "#61B3CD"
})))));

function SvgSurveyOrangesvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyOrangesvg);
export default __webpack_public_path__ + "static/media/survey-orangesvg.47364f3e.svg";
export { ForwardRef as ReactComponent };